/* eslint no-magic-numbers: 0 */
import '@babel/polyfill/noConflict';
import * as R from 'ramda';
import React, { Component } from 'react';
import { DataTable } from 'dash-table/index';
import Environment from 'core/environment';
import { memoizeOne } from 'core/memoizer';
import Logger from 'core/Logger';
import AppState, { AppMode, AppFlavor } from './AppMode';
import './style.less';
class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...AppState,
            temp_filtering: ''
        };
    }
    renderMode() {
        const mode = Environment.searchParams.get('mode');
        const flavorParam = Environment.searchParams.get('flavor');
        const flavors = flavorParam ? flavorParam.split(';') : [];
        if (flavors.indexOf(AppFlavor.FilterNative) !== -1) {
            return (React.createElement("div", null,
                React.createElement("button", { className: 'clear-filters', onClick: () => {
                        const tableProps = R.clone(this.state.tableProps);
                        tableProps.filter_query = '';
                        this.setState({ tableProps });
                    } }, "Clear Filter"),
                React.createElement("input", { style: { width: '500px' }, value: this.state.temp_filtering, onChange: e => this.setState({ temp_filtering: e.target.value }), onBlur: e => {
                        const tableProps = R.clone(this.state.tableProps);
                        tableProps.filter_query = e.target.value;
                        this.setState({ tableProps });
                    } })));
        }
        else if (mode === AppMode.TaleOfTwoTables) {
            if (!this.state.tableProps2) {
                this.setState({
                    tableProps2: R.clone(this.state.tableProps)
                });
            }
            const baseId = this.state.tableProps2 && this.state.tableProps2.id;
            return this.state.tableProps2 ? (React.createElement(DataTable, { ...this.state.tableProps2, id: baseId ? 'table2' : baseId })) : null;
        }
    }
    render() {
        return (React.createElement("div", null,
            this.renderMode(),
            React.createElement(DataTable, { setProps: this.setProps(), ...this.state.tableProps })));
    }
    setProps = memoizeOne(() => {
        return (newProps) => {
            Logger.debug('--->', newProps);
            this.setState((prevState) => ({
                tableProps: R.mergeRight(prevState.tableProps, newProps)
            }));
        };
    });
}
export default App;
